// Reads a Playtomic booking export (CSV) in the browser. Columns are found by their header names, so a column moving
// around in a later export does not break it. Only the fields the import needs are kept.

// A small CSV reader that understands quotes ("a,b" and "" inside quotes), CRLF and a leading byte-order mark
function parseCsv(text) {
  const rows = [];
  let row = [];
  let field = '';
  let quoted = false;
  const input = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text;
  for (let i = 0; i < input.length; i++) {
    const c = input[i];
    if (quoted) {
      if (c === '"') {
        if (input[i + 1] === '"') { field += '"'; i++; } else quoted = false;
      } else field += c;
    } else if (c === '"') quoted = true;
    else if (c === ',') { row.push(field); field = ''; }
    else if (c === '\n' || c === '\r') {
      if (c === '\r' && input[i + 1] === '\n') i++;
      row.push(field);
      rows.push(row);
      row = [];
      field = '';
    } else field += c;
  }
  if (field !== '' || row.length > 0) { row.push(field); rows.push(row); }
  return rows.filter(r => r.some(cell => cell.trim() !== ''));
}

const REQUIRED = ['booking_id', 'tenant_id', 'booking_start_date', 'booking_end_date', 'coach_id'];

/**
 * @returns {{ rows: Object[], error: string|null }} rows ready to send to the server
 */
export function parseBookingsCsv(text) {
  const table = parseCsv(text);
  if (table.length < 2) return { rows: [], error: 'This file has no bookings in it.' };
  const header = table[0].map(h => h.trim().toLowerCase());
  const col = (name) => header.indexOf(name);
  const missing = REQUIRED.filter(name => col(name) === -1);
  if (missing.length > 0) {
    return { rows: [], error: `This does not look like a Playtomic bookings export (missing: ${missing.join(', ')}).` };
  }
  const nameCols = header.map((h, i) => (/^participant_name_\d+$/.test(h) ? i : -1)).filter(i => i !== -1);
  const get = (r, name) => (col(name) === -1 ? '' : (r[col(name)] || '').trim());

  const rows = table.slice(1).map(r => ({
    bookingId: get(r, 'booking_id'),
    tenantId: get(r, 'tenant_id'),
    resourceName: get(r, 'resource_name'),
    start: get(r, 'booking_start_date'),
    end: get(r, 'booking_end_date'),
    coachId: get(r, 'coach_id'),
    canceled: get(r, 'is_canceled').toLowerCase() === 'true',
    status: get(r, 'status'),
    courseName: get(r, 'course_name'),
    activityName: get(r, 'activity_name'),
    names: nameCols.map(i => (r[i] || '').trim()).filter(Boolean)
  })).filter(r => r.bookingId);

  return { rows, error: rows.length === 0 ? 'This file has no bookings in it.' : null };
}
